import hubSpotLogo from '@/assets/hubspot.svg?url';
import notionLogo from '@/assets/Notion.webp?url';
import pennylaneLogo from '@/assets/pennylane.svg?url';
import pipedriveLogo from '@/assets/pipedrive.svg?url';
import { ConnectionState } from '@/services/mcpConnectors';

export type MCPConnectorInfos = {
    name: string;
    logo: string;
    accessNote?: string;
};

export const MCPConnectorConfig: Record<string, MCPConnectorInfos> = {
    hubspot: {
        name: 'HubSpot',
        logo: hubSpotLogo,
        accessNote:
            'HubSpot remembers the permissions you granted, so reconnecting later takes one click.'
    },
    notion: {
        name: 'Notion',
        logo: notionLogo,
        accessNote:
            'Notion remembers the permissions you granted, so reconnecting later takes one click.'
    },
    pennylane: {
        name: 'Pennylane',
        logo: pennylaneLogo,
        accessNote:
            'Pennylane does not remember your choices: reconnecting means selecting each permission again.'
    },
    pipedrive: {
        name: 'Pipedrive',
        logo: pipedriveLogo,
        accessNote:
            'Pipedrive remembers the permissions you granted, so reconnecting later takes one click.'
    }
};

export const MCP_STATE_LABELS: Record<ConnectionState, string> = {
    [ConnectionState.CONNECTED]: 'Connected',
    [ConnectionState.NOT_CONNECTED]: 'Not connected',
    [ConnectionState.NEEDS_RECONNECT]:
        'Access expired — reconnect to restore it'
};

export const MCP_ACTION_LABELS: Record<ConnectionState, string> = {
    [ConnectionState.CONNECTED]: 'Remove access',
    [ConnectionState.NOT_CONNECTED]: 'Connect',
    [ConnectionState.NEEDS_RECONNECT]: 'Reconnect'
};

// Not connected is a neutral fact, not a fault: only a broken connection is red.
export const MCP_STATE_CLASSES: Record<ConnectionState, string> = {
    [ConnectionState.CONNECTED]: 'text-green100',
    [ConnectionState.NOT_CONNECTED]: 'text-muted-foreground',
    [ConnectionState.NEEDS_RECONNECT]: 'text-destructive'
};
